'use strict';

/**
 * Collection for the Recent materials in the filter
 *
 * @category   Collection.FilterComponent
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Backbone = require('backbone');
var Collection = require('base/Colido.Collection');
var Model = require('base/Colido.Model');

require('backbone-localstorage');

var RecentMaterialsCollection = Collection.extend({
    api: '/',

    localStorage: new Backbone.LocalStorage('module:collection:filter:recentmaterials'),
    model: Model,

    sortDefault: 'time.desc',

    sortFieldsMap: {
        'time.desc': 'time.desc',
    },
});

module.exports = RecentMaterialsCollection;